var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-collapse',{staticClass:"advance-config-block",class:{ 'is-static': !_vm.collapsible },attrs:{"bordered":false,"activeKey":_vm.activeKeys},on:{"change":_vm.onCollapseChange}},[_c('a-collapse-panel',{key:"1",attrs:{"header":_vm.displayTitle,"forceRender":true,"showArrow":_vm.collapsible}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }